import {DateTime, nanoid} from "@2d-front-monorepo/core";
import {CustomData} from "./CustomData";
import HolderType from "./enums/HolderType";
import PermitStatusType from "./enums/PermitStatusType.js";
import ResidencyUses from "./enums/ResidencyUses";
import VehicleType from "./enums/VehicleType";
import {PermitId} from "./nominalTypes/PermitId";
import {AllPermitsResult} from "./types/AllPermitsResult";
import {CreatePermitCommand} from "./types/CreatePermitCommand";
import {GroupedPermit} from "./types/GroupedPermit";
import {PermitResult} from "./types/PermitResult.js";

class Permits {
	// static children(permits: AllPermitsResult, permit: PermitResult): PermitResult[] {
	// 	const result: PermitResult[] = [];
	// 	for (let child of permits.permits) {
	// 		const parentId = CustomData.getParentPermitId(child);
	// 		if (parentId === permit.id) {
	// 			result.push(child);
	// 		}
	// 	}
	//
	// 	return result;
	// }

	static find(permits: AllPermitsResult, id: PermitId | undefined): PermitResult | undefined {
		return id == null ? undefined : permits.permits.find(permit => permit.id === id);
	}

	static getFilteredPermits(permits: PermitResult[], groupName: string): GroupedPermit[] {
		const result: GroupedPermit[] = [];
		for (const permit of permits) {
			if (groupName === CustomData.getGroupName(permit)) {
				result.push({
					name: groupName,
					startDate: permit.startDate,
					endDate: permit.endDate,
					permit,
					permits: [permit],
					count: 1
				})
			}
		}

		return result;
	}

	static getGroupedPermits(permits: PermitResult[]): GroupedPermit[] {
		const groupMap = new Map<string, GroupedPermit>();
		const groupOrder: string[] = [];

		for (const permit of permits) {
			const groupName = CustomData.getGroupName(permit) ?? nanoid();
			const {startDate, endDate} = permit as { startDate: DateTime; endDate: DateTime };
			const group = groupMap.get(groupName);
			if (group == null) {
				groupMap.set(groupName, {
					name: groupName,
					startDate,
					endDate,
					permit,
					permits: [permit],
					count: 1
				});
				groupOrder.push(groupName);

			} else {
				group.startDate = group.startDate <= startDate ? group.startDate : startDate;
				group.endDate = group.endDate == null ? endDate : group.endDate >= endDate ? group.endDate : endDate;
				group.permits.push(permit);
				group.count++;
			}
		}

		return groupOrder.map(groupName => groupMap.get(groupName)!);
	}

	static isActive(permit: PermitResult): boolean {
		return permit.status.type === PermitStatusType.Active || permit.status.type === PermitStatusType.AboutToExpire;
	}

	/**
	 * Valid state:!(PermitStatusType.Canceled or PermitStatusType.Expired or PermitStatusType.Rejected)
	 * @param permit
	 * @param aboutToExpireIsValid -  Use true
	 * to let permits in @see {@link Dot: PermitStatusType.AboutToExpire} status to be valid, false
	 * otherwise.
	 * @returns
	 */
	static isValidState(permit: PermitResult, aboutToExpireIsValid: boolean): boolean {
		if (aboutToExpireIsValid) {
			return permit.status.type !== PermitStatusType.Cancelled && permit.status.type !== PermitStatusType.Expired && permit.status.type !== PermitStatusType.Rejected;
		}
		return permit.status.type !== PermitStatusType.Cancelled && permit.status.type !== PermitStatusType.AboutToExpire && permit.status.type !== PermitStatusType.Expired && permit.status.type !== PermitStatusType.Rejected;
	}

	static newFormContext(): CreatePermitCommand {
		return {
			customData: [],
			tariffId: null!,
			driver: {
				driverId: null!,
				attachments: {},
				customData: {},
				arguments: {
					fullName: null!,
					attachments: [],
					customData: []
				}
			},
			residency: {
				residencyId: null!,
				attachments: {},
				customData: {},
				arguments: {
					address: {},
					uses: ResidencyUses.None,
					zoneId: null!,
					attachments: [],
					customData: []
				}
			},
			vehicles: [{
				vehicleId: null!,
				attachments: {},
				customData: {},
				arguments: {
					plate: null!,
					type: VehicleType.Resident,
					attachments: [],
					customData: []
				}
			}],
			permit: {
				arguments: {
					startDate: null!,
					vehicles: [],
					customData: []
				},
				attachments: {},
				customData: {}
			},
			holder: {
				arguments: {
					type: HolderType.Undefined,
					attachments: [],
					customData: []
				},
				attachments: {},
				customData: {}
			}
		}
	}
}

export {Permits};
